if ($('.video-responsive video').length) {
  $(function() {
    $(".video-responsive video source").each(function() {
      var sourceFile = $(this).attr("data-src");
      $(this).attr("src", sourceFile);
      var video = this.parentElement;
      video.load();
      video.play();
    });
  });
}

if ($('#background-video').length) {
  document.addEventListener("DOMContentLoaded", function () {
    var video = document.getElementById("background-video");
    video.onloadeddata = function () {
      video.classList.add("loaded");
    };
  });
}